import React, { useEffect, useState } from 'react';
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { Editor } from 'primereact/editor';
import { RadioButton } from "primereact/radiobutton";
import { useFormik } from "formik";
import { trainingApi } from "../../services";
import { toast } from "react-toastify";

const TrainingFeedbackForm = ({ feedbackData, closeDialoge, reload, type, selectedFeedbackType }) => {
    const [ratingOptions, setRatingOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState('no');
    const [purposeOfTrainingAchievedOption, setPurposeOfTrainingAchievedOption] = useState('no');
    const [expectedSkillsetAchievedOption, setExpectedSkillsetAchievedOption] = useState('no');

    useEffect(() => {
        fetchRatings();
    }, []);

    const fetchRatings = () => {
        trainingApi.getRatings().then((resp) => {
            resp.data.data.sort((a, b) => a.code - b.code);
            setRatingOptions(resp.data.data);
        });
    };

    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    }


    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    const formik = useFormik({
        initialValues: {
            employeeName: selectedFeedbackType === 0 ? type === 'normal' ? feedbackData?.userDetails?.firstName + ' ' + feedbackData?.userDetails?.lastName : feedbackData?.trainingRequisitionForm?.nameOfNominatedParticipant : '',
            skillRating: null,
            outcomeAchievedStatus: '',
            trainingFeedback: '',
            trainingRequestedFeedback: '',
            trainingOutcomesFeedback: '',
        },
        validate: (data) => {
            let errors = {};
            // if (!data.outcomeAchievedStatus) errors.outcomeAchievedStatus = 'Outcome Status is required.';
            if (!data.skillRating) errors.skillRating = 'Rating is required.';
            if (!data.trainingFeedback) errors.trainingFeedback = 'Outcome Achieved Remarks is required.';
            if (!data.trainingRequestedFeedback) errors.trainingRequestedFeedback = 'Requested Training Remarks is required.';
            if (!data.trainingOutcomesFeedback) errors.trainingOutcomesFeedback = 'Business Outcome Remarks is required.';
            return errors;
        },
        onSubmit: (data) => {
            let params = {
                ids: selectedFeedbackType === 1
                    ? feedbackData.map(item => item.id)
                    : type === 'normal'
                        ? [feedbackData?.id]
                        : [feedbackData?.trainingRequisitionForm?.trainingDetails[0]?.id],

                OutcomeAchieved: selectedOption === "yes",
                purposeOfTrainingAchieved: purposeOfTrainingAchievedOption === "yes",
                expectedSkillsetAchieved: expectedSkillsetAchievedOption === "yes",
                primarySkillRating: data.skillRating,
                feedback: data.trainingFeedback,
                trainingRequestedFeedback: data.trainingRequestedFeedback,
                trainingOutcomesFeedback: data.trainingOutcomesFeedback,
                isManagerFeedback: true,
            };

            // Only add when selectedFeedbackType === 0
            if (selectedFeedbackType === 0) {
                params = {
                    ...params,
                    targetSkill: type === 'normal'
                        ? feedbackData?.targetSkills?.id
                        : feedbackData?.trainingRequisitionForm?.trainingDetails[0]?.targetSkills,
                    userId: type === 'normal'
                        ? feedbackData?.userId
                        : feedbackData?.trainingRequisitionForm?.userId,
                };
            }
            try {
                trainingApi.updateEmployeeTraining(params).then(
                    (resp) => {
                        toast.success(resp.data.message);
                        setTimeout(() => {
                            closeDialoge();
                            reload();
                        }, 1000);
                    },
                    (err) => {
                        toast.error(err.response.data.error);
                    }
                );
            } catch (error) {
                toast.error("Unable to update");
            }

        },
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} autoComplete='off'>
                <div className="flex flex-wrap p-field font-bold block">
                    {selectedFeedbackType === 0 &&
                        <>
                            <div className="col-4 mt-2">
                                <label htmlFor="employeeName" className="font-bold block mb-2 training-heading">
                                    Employee Name
                                </label>
                                <div className="p-inputgroup flex-1">
                                    <span className="p-inputgroup-addon"><i className="pi pi-user"></i></span>{" "}
                                    <InputText id="text" disabled placeholder="Name" className="w-full" name="employeeName" value={formik.values.employeeName} onChange={formik.handleChange} />
                                </div>
                            </div>

                            <div className="col-4">
                                <label htmlFor="skillRating" className="font-bold block mb-2 training-heading mt-2">
                                    Target Skill
                                </label>
                                <InputText id="text" disabled placeholder="Name" className="w-full" name="employeeName" value={type === 'normal' ? feedbackData?.targetSkills?.title : feedbackData?.trainingRequisitionForm?.targetSkills?.title} />
                            </div>
                        </>
                    }

                    <div className="col-4">
                        <label htmlFor="skillRating" className="font-bold block mb-2 training-heading mt-2">
                            Skill Rating Update
                        </label>
                        <Dropdown name="skillRating" value={formik.values.skillRating} options={ratingOptions} optionLabel={(option) => `${option.code} - ${option.title}`} optionValue="code" onChange={(e) => formik.handleChange(e)} placeholder="Select Rating" className="w-full" />
                        {getFormErrorMessage('skillRating')}
                    </div>
                </div>

                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-4">
                        <label htmlFor="outcomeAchieved" className="font-bold block mb-2 training-heading mt-2">
                            Business Outcome Achieved
                        </label>
                        <div className="flex align-items-center">
                            <RadioButton inputId="yes" name="outcomeAchieved" value="yes" className="mt-2" checked={selectedOption === 'yes'} onChange={(e) => setSelectedOption(e.value)} />
                            <label htmlFor="yes" className="ml-2 mt-2">Yes</label>
                            <RadioButton inputId="no" name="outcomeAchieved" value="no" className="ml-4 mt-2" checked={selectedOption === 'no'} onChange={(e) => setSelectedOption(e.value)} />
                            <label htmlFor="no" className="ml-2 mt-2">No</label>
                        </div>
                    </div>
                    <div className="col-4">
                        <label htmlFor="purposeOfTrainingAchieved" className="font-bold block mb-2 training-heading mt-2">
                            Purpose Of Training Achieved
                        </label>
                        <div className="flex align-items-center">
                            <RadioButton inputId="yes" name="purposeOfTrainingAchieved" value="yes" className="mt-2" checked={purposeOfTrainingAchievedOption === 'yes'} onChange={(e) => setPurposeOfTrainingAchievedOption(e.value)} />
                            <label htmlFor="yes" className="ml-2 mt-2">Yes</label>
                            <RadioButton inputId="no" name="purposeOfTrainingAchieved" value="no" className="ml-4 mt-2" checked={purposeOfTrainingAchievedOption === 'no'} onChange={(e) => setPurposeOfTrainingAchievedOption(e.value)} />
                            <label htmlFor="no" className="ml-2 mt-2">No</label>
                        </div>
                    </div>
                    <div className="col-4">
                        <label htmlFor="expectedSkillsetAchieved" className="font-bold block mb-2 training-heading mt-2">
                            Expected Level Of Skillset Achieved
                        </label>
                        <div className="flex align-items-center">
                            <RadioButton inputId="yes" name="expectedSkillsetAchieved" value="yes" className="mt-2" checked={expectedSkillsetAchievedOption === 'yes'} onChange={(e) => setExpectedSkillsetAchievedOption(e.value)} />
                            <label htmlFor="yes" className="ml-2 mt-2">Yes</label>
                            <RadioButton inputId="no" name="expectedSkillsetAchieved" value="no" className="ml-4 mt-2" checked={expectedSkillsetAchievedOption === 'no'} onChange={(e) => setExpectedSkillsetAchievedOption(e.value)} />
                            <label htmlFor="no" className="ml-2 mt-2">No</label>
                        </div>
                    </div>
                </div>

                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-12">
                        <label htmlFor="feedback" className="font-bold block mb-2 training-heading mt-2">
                            Outcome Achieved Remarks
                        </label>
                        {/* <Editor headerTemplate={renderHeader} style={{ height: '200px' }} placeholder="Provide feedback" /> */}
                        <InputTextarea name="trainingFeedback" value={formik.values.trainingFeedback} onChange={formik.handleChange} placeholder="Feedback" rows={4} className="w-full" style={{ background: "#fff" }} />
                        {getFormErrorMessage('trainingFeedback')}
                    </div>
                </div>

                {/* {selectedFeedbackType === 0 &&
                    <> */}
                <div className="flex flex-wrap p-field font-bold block">
                    <label htmlFor="expectedOutcome" className="font-bold block mb-2 training-heading">
                        Purpose of Requested Training
                    </label>
                </div>
                <div className="grid">
                    {selectedFeedbackType === 0 || selectedFeedbackType === 1 ? (
                        <div className="mp-panel col-12">
                            {(selectedFeedbackType === 0
                                ? feedbackData?.trainingPurposeDetails
                                : feedbackData?.[0]?.trainingPurposeDetails
                            )?.map((item, index) => (
                                <div key={index} className="col mr-2 bordered mt-1">
                                    {item.title}
                                </div>
                            ))}
                        </div>
                    ) : null}
                </div>
                {/* </>
                } */}

                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-12">
                        <label htmlFor="feedback" className="font-bold block mb-2 training-heading mt-2">
                            Purpose of Requested Training Remarks
                        </label>
                        {/* <Editor headerTemplate={renderHeader} style={{ height: '200px' }} placeholder="Provide feedback" /> */}
                        <InputTextarea name="trainingRequestedFeedback" value={formik.values.trainingRequestedFeedback} onChange={formik.handleChange} placeholder="Feedback" rows={4} className="w-full" style={{ background: "#fff" }} />
                        {getFormErrorMessage('trainingRequestedFeedback')}
                    </div>
                </div>

                {/* {selectedFeedbackType === 0 &&
                    <> */}
                <div className="flex flex-wrap p-field font-bold block">
                    <label htmlFor="expectedOutcome" className="font-bold block mb-2 training-heading">
                        Expected Business Outcome
                    </label>
                </div>
                <div className="grid">
                    {/* <div className="mp-panel col-12">
                                {feedbackData?.businessoutcomeDetails?.map((item, index) => (
                                    <div className='col mr-2 bordered mt-1'>
                                        {item.title}
                                    </div>
                                ))}
                            </div> */}

                    {selectedFeedbackType === 0 || selectedFeedbackType === 1 ? (
                        <div className="mp-panel col-12">
                            {(selectedFeedbackType === 0
                                ? feedbackData?.businessoutcomeDetails
                                : feedbackData?.[0]?.businessoutcomeDetails
                            )?.map((item, index) => (
                                <div key={index} className="col mr-2 bordered mt-1">
                                    {item.title}
                                </div>
                            ))}
                        </div>
                    ) : null}
                </div>
                {/* </>
                } */}

                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-12">
                        <label htmlFor="feedback" className="font-bold block mb-2 training-heading mt-2">
                            Expected Business Outcome Remarks
                        </label>
                        {/* <Editor headerTemplate={renderHeader} style={{ height: '200px' }} placeholder="Provide feedback" /> */}
                        <InputTextarea name="trainingOutcomesFeedback" value={formik.values.trainingOutcomesFeedback} onChange={formik.handleChange} placeholder="Feedback" rows={4} className="w-full" style={{ background: "#fff" }} />
                        {getFormErrorMessage('trainingOutcomesFeedback')}
                    </div>
                </div>
                <div className="flex flex-wrap p-field font-bold block mt-2">
                    <div className="col-12">
                        <p className="guidelines">
                            <strong>Skill Updating Guidelines:</strong> Ensure that the feedback
                            is constructive and aligns with the skill development goals. Ratings
                            should reflect the employee's performance in the training.
                        </p>
                    </div>
                </div>

                <hr />
                <div className='' style={{ textAlign: 'right' }}>
                    <Button label='Update' icon='pi pi-save' severity='primary' className='mr-1' />
                    <Button type='button' label='Cancel' icon='pi pi-times' severity='secondary' onClick={closeDialoge} />
                </div>
            </form>
        </>
    )
}

export default TrainingFeedbackForm;